import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BankService {

  constructor(public http:HttpClient) { }

  getBankList(countryid){
    return this.http.get(environment.api_link+"/api/get_banks_list/"+countryid)
  }

  getBankName(ifsc){
    return this.http.get(environment.api_link+"/api/get_ifsc/"+ifsc)
  }

  getName(bankcode,account_numner){
    return this.http.get(environment.api_link+"/api/get_account_holder_name/"+bankcode+"/"+account_numner)
  }

  
}
